var m = require('mithril');


var _window = window;
var _document = document;
var mousemove = 'mousemove';
var mouseup = 'mouseup';
var mousedown = 'mousedown';
var EventListener = 'EventListener';
var addEventListener = 'add'+EventListener;
var removeEventListener = 'remove'+EventListener;
var newScrollX, newScrollY;
var click = 'click';
var dragClickThreshold = 3;

var dragged = [];
var reset = function(i, el) {
    for (i = 0; i < dragged.length;) {
    el = dragged[i++];
    el = el.container || el;
    el[removeEventListener](mousedown, el.md, 0);
    _window[removeEventListener](mouseup, el.mu, 0);
    _window[removeEventListener](mousemove, el.mm, 0);
    _window[removeEventListener](click, el.cl, true);
    }

    // cloning into array since HTMLCollection is updated dynamically
    dragged = [].slice.call(_document.getElementsByClassName('dragscroll'));
    for (i = 0; i < dragged.length;) {
    (function(el, lastClientX, lastClientY, startClientX, startClientY, pushed, scroller, cont, draggedEnough, suppressClick){
        (cont = el.container || el)[addEventListener](
            mousedown,
            cont.md = function(e) {
            if (e.target.tagName === "SELECT"
            || e.target.tagName === "INPUT"
            || e.target.tagName === "TEXTAREA"
            ) {               
                return true
            }
            if (!el.hasAttribute('nochilddrag') ||
                _document.elementFromPoint(
                    e.pageX, e.pageY
                ) == cont
            ) {
                pushed = 1;
                lastClientX = e.clientX;
                lastClientY = e.clientY;
                startClientX = e.clientX;
                startClientY = e.clientY;
                draggedEnough = false;
                suppressClick = false;

                e.preventDefault();
            }
            }, 0
        );

        _window[addEventListener](
            mouseup, cont.mu = function() {
                if (pushed && draggedEnough) {
                    suppressClick = true;
                }
                pushed = 0;
            }, 0
        );

        _window[addEventListener](
            mousemove,
            cont.mm = function(e) {
            if (pushed) {
                if (
                    Math.abs(e.clientX - startClientX) > dragClickThreshold ||
                    Math.abs(e.clientY - startClientY) > dragClickThreshold
                ) {
                    draggedEnough = true;
                }
                (scroller = el.scroller||el).scrollLeft -=
                    newScrollX = (- lastClientX + (lastClientX=e.clientX));
                scroller.scrollTop -=
                    newScrollY = (- lastClientY + (lastClientY=e.clientY));
                if (el == _document.body) {
                    (scroller = _document.documentElement).scrollLeft -= newScrollX;
                    scroller.scrollTop -= newScrollY;
                }
            }
            }, 0
        );
        _window[addEventListener](
            click,
            cont.cl = function(e) {
                if (!suppressClick) return;
                suppressClick = false;
                e.preventDefault();
                e.stopPropagation();
                if (e.stopImmediatePropagation) {
                    e.stopImmediatePropagation();
                }
            },
            true
        );
    })(dragged[i++]);
    }
}

var dragscroll = function(vnode) {
  reset();
};

module.exports = dragscroll;
